module.exports = __webpack_public_path__ + "static/img/cjgyTu1@2x.53ed84fa.png";